import {
  IApiResponse,
  IPatchUserSessionInfo,
  IUserSession,
  IUserSessionPatch,
  IUserSessionPost,
  ITermsConfirmation,
  IXrayManualConfirmation
} from 'types'
import {
  PROFESSIONAL,
  CRUD,
  IMAGE,
  PROFESSIONAL_TO_ADD,
  SESSION,
  USER_REGISTRATION_BASE,
  USER_REGISTRATION_BASE_V2,
  ACCEPT_TERMS,
  ACCEPT_XRAY_MANUAL
} from './CONSTANTS'
import { IRequestOptions, request } from 'services/base'

export const session = async (): Promise<IApiResponse<IUserSession>> =>
  await request({ url: SESSION, method: 'get' })

export const patchSession = async (
  data?: IPatchUserSessionInfo
): Promise<IApiResponse<IUserSession>> =>
  await request({ url: SESSION, method: 'patch', data })

export const patchUser = async (
  userId: string,
  data: IUserSession
): Promise<IApiResponse<any>> =>
  await request({ url: CRUD(userId), method: 'patch', data })

export const patchProfessional = async (
  userId: string,
  data: IUserSessionPatch,
  headers: IRequestOptions['headers']
): Promise<IApiResponse<any>> =>
  await request({ url: PROFESSIONAL(userId), method: 'patch', data, headers })

export const patchImage = async (
  userId: string,
  data: FormData
): Promise<IApiResponse<any>> =>
  await request({ url: IMAGE(userId), method: 'patch', data })

export const postUser = async (
  data: IUserSessionPost,
  establishmentId: string
) =>
  await request({
    url: USER_REGISTRATION_BASE_V2,
    method: 'post',
    data,
    headers: { establishment: establishmentId }
  })

export const acceptTerms = async (
  confirmations: ITermsConfirmation[]
): Promise<IApiResponse<unknown>> =>
  await request({ url: ACCEPT_TERMS, method: 'post', data: { confirmations } })

export const acceptXrayManual = async (
  confirmations: IXrayManualConfirmation[]
): Promise<IApiResponse<unknown>> =>
  await request({
    url: ACCEPT_XRAY_MANUAL,
    method: 'post',
    data: { confirmations }
  })

export const getUserList = async (): Promise<IApiResponse<IUserSession[]>> =>
  await request({ url: USER_REGISTRATION_BASE, method: 'get' })

export const searchProfessionalsByEmail = async (
  email: string
): Promise<IApiResponse<any>> =>
  await request({
    url: PROFESSIONAL_TO_ADD,
    method: 'get',
    params: { email: email }
  })
